import { useTranslation } from '../i18n/I18nProvider'

/**
 * A small "coming soon" ribbon for an option that is visible but not yet actionable — e.g. an
 * operating state D87 reserves and refuses server-side. Purely presentational: it carries no
 * `disabled` state of its own, so the control it sits on must still refuse the tap itself.
 */
export function SoonBadge(): JSX.Element {
  const { t } = useTranslation('common')
  return <span className="soon-badge">{t('soonBadge')}</span>
}
